<div class="auction_items mb-4">
    <h3 *ngIf="IsRoom">{{title|titlecase}}</h3>
    <div class="d-flex justify-content-center align-items-center" *ngIf="!IsRoom">
        <div class="filter_list">
            <div class="filter_item" [class.active]="item.key == AuctionListFilter.type" (click)="onSelectType(item,i)"
                matRipple *ngFor="let item of filterItems;let i=index">
                <span class="text">{{item.value|translate}}</span> <span class="count mx-2">{{item.count}}</span>
            </div>

        </div>
    </div>

    <div class="tableHeader container-fluid" *ngIf="showFilterBar">
        <!-- <div class="row">
            <div class="col-xl-6 clo-md-6 col-sm-6 col-12 sort">
                <p class="d-inline"> <span class="total">{{total}}</span> {{"items-requests.Auction's Items" | translate}}</p>
                <div class="d-inline">
                    {{'filter.sortBy' | translate}}:

                    <button mat-button class="btnLight_fill" [matMenuTriggerFor]="menu">{{sortByText|translate}} <svg
                            xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5">
                            <path id="arrow"
                                d="M15.5,9.112a.9.9,0,0,0-1.2,0l-3.065,2.834L8.211,9.112a.9.9,0,0,0-1.2,0,.766.766,0,0,0,0,1.137l3.62,3.394a.894.894,0,0,0,1.212,0L15.5,10.249a.766.766,0,0,0,0-1.137Z"
                                transform="translate(-6.754 -8.879)" fill="#70639e" />
                        </svg>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngFor="let item of sortingList" (click)="OnSelectSort(item)">{{item.key
                            |translate}}</button>
                    </mat-menu>
                </div>
            </div>
            <div class="col-xl-6 clo-md-6 col-sm-6 col-12 filter_search">
                <div class="d-inline-flex align-items-center flex-wrap">
                   
                    <a (click)="OnToggleSearch()">
                        <span [ngSwitch]="showSearch">
                            <p *ngSwitchCase="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.997"
                                    viewBox="0 0 20 19.997">
                                    <path id="search"
                                        d="M21.7,20.29,17.99,16.61A8.992,8.992,0,1,0,16.6,18l3.678,3.68A.993.993,0,1,0,21.7,20.29ZM10.995,18a7,7,0,1,1,7-7,7,7,0,0,1-7,7Z"
                                        transform="translate(-1.979 -1.979)" fill="#8479ac" />
                                </svg>
                            </p>
                            <p *ngSwitchCase="true">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998"
                                    viewBox="0 0 13.998 13.998">
                                    <path id="close-btn"
                                        d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                                        transform="translate(5.82 13.32)" fill="#bbb" />
                                </svg>
                            </p>
                        </span>
                    </a>

                    <button mat-button class="btnLight_fill" (click)="showFilter=!showFilter">


                        <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                <path id="filter"
                                    d="M15.6,2H4.4A2.4,2.4,0,0,0,2,4.4v.936a2.4,2.4,0,0,0,.2.96v.048a2.248,2.248,0,0,0,.472.688l4.928,4.9V17.2a.8.8,0,0,0,1.16.712l3.2-1.6a.8.8,0,0,0,.44-.712V11.928l4.9-4.9a2.248,2.248,0,0,0,.472-.688V6.3A2.4,2.4,0,0,0,18,5.336V4.4A2.4,2.4,0,0,0,15.6,2Zm-4.568,9.032a.8.8,0,0,0-.232.568v3.5l-1.6.8V11.6a.8.8,0,0,0-.232-.568L6.3,8.371,4.728,6.8H15.272ZM16.4,5.2H3.6V4.4a.8.8,0,0,1,.8-.8H15.6a.8.8,0,0,1,.8.8Z"
                                    transform="translate(-2 -2)" fill="#70639e" />
                            </svg>{{'filter.filter' | translate}}</span> <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5"
                            viewBox="0 0 9 5">
                            <path id="arrow"
                                d="M15.5,9.112a.9.9,0,0,0-1.2,0l-3.065,2.834L8.211,9.112a.9.9,0,0,0-1.2,0,.766.766,0,0,0,0,1.137l3.62,3.394a.894.894,0,0,0,1.212,0L15.5,10.249a.766.766,0,0,0,0-1.137Z"
                                transform="translate(-6.754 -8.879)" fill="#70639e" />
                        </svg>
                    </button>

                    <button IsAdmin mat-button class="btn_fill" (click)="OpenAddAuctionItem.emit(true)"
                        *ngIf="IsRoom">{{'items-requests.Add New Item' | translate}}</button>
                </div>

            </div>
        </div> -->

        <div class="page-filters webView">
            <div class="sort-item">
                <div class="count-item">
                    <span class="counter"> {{ total }} </span>
                    {{"items-requests.Auction's Items" | translate}}
                </div>
                <label>{{'filter.sortBy' | translate}}:</label>
                <button mat-button class="btnLight_fill" [matMenuTriggerFor]="menu">{{sortByText|translate}} <svg
                        xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5">
                        <path id="arrow"
                            d="M15.5,9.112a.9.9,0,0,0-1.2,0l-3.065,2.834L8.211,9.112a.9.9,0,0,0-1.2,0,.766.766,0,0,0,0,1.137l3.62,3.394a.894.894,0,0,0,1.212,0L15.5,10.249a.766.766,0,0,0,0-1.137Z"
                            transform="translate(-6.754 -8.879)" fill="#70639e" />
                    </svg>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item *ngFor="let item of sortingList" (click)="OnSelectSort(item)">{{item.key
                        |translate}}</button>
                </mat-menu>
            </div>
            <div class="filters-container">
                <a (click)="onCancelSearch()">
                    <span [ngSwitch]="showSearch">
                        <p *ngSwitchCase="false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.997" viewBox="0 0 20 19.997">
                                <path id="search"
                                    d="M21.7,20.29,17.99,16.61A8.992,8.992,0,1,0,16.6,18l3.678,3.68A.993.993,0,1,0,21.7,20.29ZM10.995,18a7,7,0,1,1,7-7,7,7,0,0,1-7,7Z"
                                    transform="translate(-1.979 -1.979)" fill="#8479ac" />
                            </svg>
                        </p>
                        <p *ngSwitchCase="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998"
                                viewBox="0 0 13.998 13.998">
                                <path id="close-btn"
                                    d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                                    transform="translate(5.82 13.32)" fill="#bbb" />
                            </svg>
                        </p>
                    </span>
                </a>
                <button (click)="showFilter = !showFilter" mat-button [ngClass]="{ active: showFilter }"
                    class="btn dropdown-custom dropdown-toggle">
                    <!-- <img alt="" src="../../../../../assets/images/icons/filter-icon.svg" /> -->
                    <span>{{'filter.filter' | translate}}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                        <path id="filter"
                            d="M15.6,2H4.4A2.4,2.4,0,0,0,2,4.4v.936a2.4,2.4,0,0,0,.2.96v.048a2.248,2.248,0,0,0,.472.688l4.928,4.9V17.2a.8.8,0,0,0,1.16.712l3.2-1.6a.8.8,0,0,0,.44-.712V11.928l4.9-4.9a2.248,2.248,0,0,0,.472-.688V6.3A2.4,2.4,0,0,0,18,5.336V4.4A2.4,2.4,0,0,0,15.6,2Zm-4.568,9.032a.8.8,0,0,0-.232.568v3.5l-1.6.8V11.6a.8.8,0,0,0-.232-.568L6.3,8.371,4.728,6.8H15.272ZM16.4,5.2H3.6V4.4a.8.8,0,0,1,.8-.8H15.6a.8.8,0,0,1,.8.8Z"
                            transform="translate(-2 -2)" fill="#70639e" />
                    </svg>
                </button>
                <div class="create-item">
                    <button IsAdmin (click)="OpenAddAuctionItem.emit(true)" mat-button class="btn_fill" *ngIf="IsRoom">
                        <span> {{'items-requests.Add New Item' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="page-filters mobileView">
            <div class="count-item d-block">
                <span class="counter"> {{ total }} </span>
                {{"items-requests.Auction's Items" | translate}}
            </div>

            <div class="sort-item">
                <button mat-button class="btnLight_fill" [matMenuTriggerFor]="menu">{{sortByText|translate}} <svg
                        xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5">
                        <path id="arrow"
                            d="M15.5,9.112a.9.9,0,0,0-1.2,0l-3.065,2.834L8.211,9.112a.9.9,0,0,0-1.2,0,.766.766,0,0,0,0,1.137l3.62,3.394a.894.894,0,0,0,1.212,0L15.5,10.249a.766.766,0,0,0,0-1.137Z"
                            transform="translate(-6.754 -8.879)" fill="#70639e" />
                    </svg>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item *ngFor="let item of sortingList" (click)="OnSelectSort(item)">{{item.key
                        |translate}}</button>
                </mat-menu>
                <a (click)="onCancelSearch()">
                    <span [ngSwitch]="showSearch">
                        <p *ngSwitchCase="false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.997" viewBox="0 0 20 19.997">
                                <path id="search"
                                    d="M21.7,20.29,17.99,16.61A8.992,8.992,0,1,0,16.6,18l3.678,3.68A.993.993,0,1,0,21.7,20.29ZM10.995,18a7,7,0,1,1,7-7,7,7,0,0,1-7,7Z"
                                    transform="translate(-1.979 -1.979)" fill="#8479ac" />
                            </svg>
                        </p>
                        <p *ngSwitchCase="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998"
                                viewBox="0 0 13.998 13.998">
                                <path id="close-btn"
                                    d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
                                    transform="translate(5.82 13.32)" fill="#bbb" />
                            </svg>
                        </p>
                    </span>
                </a>
            </div>
            <div class="filters-container">
                <button (click)="showFilter = !showFilter" mat-button [ngClass]="{ active: showFilter }"
                    class="btn dropdown-custom dropdown-toggle">
                    <!-- <img alt="" src="../../../../../assets/images/icons/filter-icon.svg" /> -->
                    <span>{{'filter.filter' | translate}}</span>&nbsp;
                    <img src="./assets/images/icons/selectArrow.svg" alt="">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                        <path id="filter"
                            d="M15.6,2H4.4A2.4,2.4,0,0,0,2,4.4v.936a2.4,2.4,0,0,0,.2.96v.048a2.248,2.248,0,0,0,.472.688l4.928,4.9V17.2a.8.8,0,0,0,1.16.712l3.2-1.6a.8.8,0,0,0,.44-.712V11.928l4.9-4.9a2.248,2.248,0,0,0,.472-.688V6.3A2.4,2.4,0,0,0,18,5.336V4.4A2.4,2.4,0,0,0,15.6,2Zm-4.568,9.032a.8.8,0,0,0-.232.568v3.5l-1.6.8V11.6a.8.8,0,0,0-.232-.568L6.3,8.371,4.728,6.8H15.272ZM16.4,5.2H3.6V4.4a.8.8,0,0,1,.8-.8H15.6a.8.8,0,0,1,.8.8Z"
                            transform="translate(-2 -2)" fill="#70639e" />
                    </svg> -->
                </button>
                <div class="create-item">
                    <button (click)="OpenAddAuctionItem.emit(true)" mat-button class="btn_fill" IsAdmin *ngIf="IsRoom">
                        <span> {{'items-requests.Add New Item' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="row filter-section" *ngIf="showFilter">

            <div class="col-md-9 col-12">
                <div class="d-inline">
                    <mat-form-field appearance="outline" class="mb-2  ">
                        <mat-label>{{'Auctions.Start date' | translate}}</mat-label>
                        <input matInput [max]="AuctionListFilter.end_date" [matDatepicker]="picker1"
                            [(ngModel)]="AuctionListFilter.start_date">
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1>
                            <mat-datepicker-actions>
                                <button mat-button matDatepickerCancel>{{'Auction Item.Cancel' | translate}}</button>
                                <button mat-button color="primary" matDatepickerApply
                                    (click)="GetAuctions()">{{'bidders.Apply' | translate}}</button>
                            </mat-datepicker-actions>
                        </mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="mb-2 ">
                        <mat-label>{{'Auctions.End date' | translate}}</mat-label>
                        <input matInput [min]="AuctionListFilter.start_date" [matDatepicker]="picker"
                            [(ngModel)]="AuctionListFilter.end_date">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker>
                            <mat-datepicker-actions>
                                <button mat-button matDatepickerCancel>{{'Auction Item.Cancel' | translate}}</button>
                                <button mat-button color="primary" matDatepickerApply
                                    (click)="GetAuctions()">{{'bidders.Apply' | translate}}</button>
                            </mat-datepicker-actions>
                        </mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="mb-2 ">
                        <mat-label>{{'Auctions.Category' | translate}}</mat-label>
                        <mat-select [(ngModel)]="AuctionListFilter.category_id" (ngModelChange)="GetAuctions()"
                            name="item">
                            <mat-option *ngFor="let item of categoriesList" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="mb-2 " *ngIf="IsRoom">
                        <mat-label>{{'Main Auction.Status' | translate}}</mat-label>
                        <mat-select [(ngModel)]="AuctionListFilter.isPublished" (ngModelChange)="GetAuctions()"
                            name="item">
                            <mat-option [value]="1">
                                {{'Main Auction.published' | translate}}
                            </mat-option>
                            <mat-option [value]="0">
                                {{'items-requests.Unpublished' | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="mb-2 " *ngIf="IsRoom">
                        <mat-label>{{'Main Auction.Type' | translate}}</mat-label>
                        <mat-select [(ngModel)]="AuctionListFilter.filterType" (ngModelChange)="GetAuctions()"
                            name="item">
                            <mat-option [value]="'upcoming'">
                                {{'Main Auction.upcoming' | translate}}
                            </mat-option>
                            <mat-option [value]="'ongoing'">
                                {{'Main Auction.ongoing' | translate}}
                            </mat-option>
                            <mat-option [value]="'completed'">
                                {{'Main Auction.completed' | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="mb-2 " *ngIf="!IsRoom">
                        <mat-label>{{'items-requests.Is Winner' | translate}}</mat-label>
                        <mat-select [(ngModel)]="AuctionListFilter.status" (ngModelChange)="GetAuctions()" name="item">
                            <mat-option [value]="'winner'">
                                {{'items-requests.Yes' | translate}}
                            </mat-option>
                            <mat-option [value]="''">
                                {{'items-requests.All' | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>


                </div>
            </div>
            <div class="col-md-3 col-12">
                <div class="group_btn">
                    <!-- <button mat-button class="btn_fill" (click)="GetAuctions()">Apply</button> -->
                    <button mat-button class="btnLight_fill"
                        (click)="onClearFiltrs()">{{"items-requests.Clear"|translate}}</button>
                </div>
            </div>
        </div>
        <div class="search_bar row" *ngIf="showSearch">
            <form class="col-md-10 col-sm-8 col-8" *ngIf="showSearch" (ngSubmit)="OnSearchText()">
                <mat-form-field appearance="fill">
                    <mat-label>{{'Home.Search' | translate}}</mat-label>
                    <input type="text" [(ngModel)]="AuctionListFilter.search" [ngModelOptions]="{standalone:true}"
                        matInput placeholder="">
                    <mat-icon mat-button matSuffix (click)="OnSearchText()">search</mat-icon>
                </mat-form-field>
            </form>
            <button mat-button class="btnLight_fill col-md-2 col-sm-4 col-4"
                (click)="AuctionListFilter.search='';OnSearchText()">{{"items-requests.Clear"|translate}}</button>
        </div>
    </div>
    <div class="list" *ngIf="!loadingData">
        <ng-container *ngIf="AuctionList?.length; else elseTemplate">

            <app-auction-item-card [AuctionData]="element" [ShowBageIcons]="!IsRoom"
                *ngFor="let element of AuctionList;let i=index"></app-auction-item-card>

            <div class="mt-3">
                <div class="text-center" *ngIf="!IsRoom">
                    <mat-paginator class="mt-3" [length]="total" (page)="handlePageEvent($event)"
                        [pageSize]="this.AuctionListFilter.perPage" [pageSizeOptions]="[10,20,50]"
                        [pageIndex]="this.AuctionListFilter.page" aria-label="Select page">
                    </mat-paginator>
                </div>

                <!-- <div class="text-center" *ngIf="AuctionListFilter.type=='ongoing'">
                    <mat-paginator class="mt-3" [length]="filterItems[1].count" (page)="handlePageEvent($event)"
                        [pageSize]="this.AuctionListFilter.perPage" [pageSizeOptions]="[10,20,50]"
                        [pageIndex]="this.AuctionListFilter.page" aria-label="Select page">
                    </mat-paginator>
                </div>

                <div class="text-center" *ngIf="AuctionListFilter.type=='completed'">
                    <mat-paginator class="mt-3" [length]="CurrentListLength" (page)="handlePageEvent($event)"
                        [pageSize]="this.AuctionListFilter.perPage" [pageSizeOptions]="[10,20,50]"
                        [pageIndex]="this.AuctionListFilter.page" aria-label="Select page">
                    </mat-paginator>
                </div> -->

                <div class="text-center" *ngIf="IsRoom">
                    <mat-paginator class="mt-3" #paginator [length]="total" (page)="handlePageEvent($event)"
                        [pageSize]="this.AuctionListFilter.perPage" [pageSizeOptions]="[10,20,50]"
                        [pageIndex]="this.AuctionListFilter.page" aria-label="Select page">
                    </mat-paginator>
                </div>
            </div>


        </ng-container>
        <ng-template #elseTemplate>
            <div class="no-data">
                <img src="assets/images/Auctions_no_data.svg" alt="">
                <p *ngIf="!IsRoom">{{'items-requests.No auctions joined yet' | translate}}</p>
                <p *ngIf="IsRoom">{{'items-requests.No items added yet' | translate}}</p>
                <button IsAdmin mat-button class="btn_fill" *ngIf="IsRoom &&authUser?.user?.role_code =='Admin'"
                    (click)="OpenAddAuctionItem.emit(true)">{{'Auctions.Add Item' | translate}}</button>
            </div>
        </ng-template>
    </div>
    <app-loading *ngIf="loadingData"></app-loading>
</div>